import { render } from "./MeusProjetos.vue?vue&type=template&id=78dc8576&scoped=true"
import script from "./MeusProjetos.vue?vue&type=script&lang=js"
export * from "./MeusProjetos.vue?vue&type=script&lang=js"

import "./MeusProjetos.vue?vue&type=style&index=0&id=78dc8576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78dc8576"]])

export default __exports__